const loginUrl = '/login';
const logoutUrl = '/logout/callback';

export { logoutUrl };
export default loginUrl;
